import { render, staticRenderFns } from "./no-login.vue?vue&type=template&id=ed4c547a&"
import script from "./no-login.vue?vue&type=script&lang=js&"
export * from "./no-login.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports